import { h, Component } from 'preact';
import style from './index.less'

const Container = (props)=>{
    const classes = [style.container];
    props.class && classes.push(props.class);
    
    if(props.type == 'transparent') classes.push(style.transparent)
    if(props.selected) classes.push(style.selected);
    
    if(props.radius == false) classes.push(style.noRadius)
    
    const headerClasses = [style.title];
    if(props.headerClass) headerClasses.push(props.headerClass);
    
    const bodyClasses = [style.body];
    if(props.bodyClass) bodyClasses.push(props.bodyClass)

    return (
        <div class={classes.join(' ')} onClick={props.onClick} key={props.key}>
            {/* {props.title && (
                <div class={headerClasses.join(' ')}>
                    <h2>{props.title}</h2>
                </div>
            )} */}
            <div class={bodyClasses.join(' ')}>
                {props.children}
            </div>
        </div>
    )
}

export default Container



// WEBPACK FOOTER //
// ./components/elements/Container/index.js